import React from 'react';
import MarketingStepsShell from './MarketingStepsShell';
import { demoStep3Actions, demoStep3Goals } from './marketingStepDemoData';
import '../Step3/EstablishAction/EstablishActionSection.css';
import '../Step3/EstablishAction/TemplateAction/SelectedAction.css';
import '../Step3/EstablishAction/TemplateAction/SelectedGoal7.css';
import './MarketingAssets.css';

const FORMAT_DATE = new Intl.DateTimeFormat('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
});

/** Static Top 7 goal row — stacked text + date for marketing capture. */
const MarketingTop7GoalRow = ({ goal, index }) => (
    <section
        className="ActionSelected Action__content marketing-step3__goal-row"
        style={{ backgroundColor: goal.color }}
    >
        <section className="SelectActionNumber__content SelectActionNumber marketing-step3__goal-number">
            {index + 1}
        </section>
        <section className="SelectedGoal__Content marketing-step3__goal-body">
            <div className="GoalSelectedAction marketing-step3__goal-text">
                {goal.text}
            </div>
            <time
                className="marketing-step3__goal-date"
                dateTime={goal.completedByDate}
            >
                {FORMAT_DATE.format(new Date(goal.completedByDate))}
            </time>
        </section>
    </section>
);

/** V1 Step 3 — Establish daily action steps (production layout, static). */
const MarketingStep3Preview = () => (
    <MarketingStepsShell activeStep={2} className="marketing-step3">
        <section className="EstablishAction__content">
            <section className="EstablishActionMyTop7__content">
                <div className="TitleActionSteps">MY TOP 7:</div>
                <h6 className="DescriptionActionSteps">
                    These are your top 7 goals{' '}
                </h6>
                {demoStep3Goals.map((goal, index) => (
                    <MarketingTop7GoalRow
                        key={goal.id}
                        goal={goal}
                        index={index}
                    />
                ))}
            </section>
            <section className="EstablishDailyAction__content">
                <div className="TitleActionSteps">
                    ESTABLISH 3 DAILY ACTION STEPS
                </div>
                <h6 className="DescriptionActionSteps">
                    Define 3 or more action steps that you will take in the next
                    24 hours towards your Top 7 goals
                </h6>
                {demoStep3Actions.map((action, index) => (
                    <section
                        key={action.text}
                        className="SelectAction__content ActionFill"
                    >
                        <div className="SelectActionNumber__content">
                            <div className="SelectActionNumber SelectActionNumberFill">
                                {index + 1}
                            </div>
                        </div>
                        <div className="inputDailyAction__content">
                            <textarea
                                readOnly
                                className="inputDailyAction InputActionFill"
                                value={action.text}
                            />
                            <hr className="secondlineActionGoalV secondlineActionGoalFill" />
                        </div>
                    </section>
                ))}
                <div className="divAdd">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        style={{ transform: 'rotate(45deg)' }}
                    >
                        <defs>
                            <clipPath id="marketing-add-more">
                                <rect width="40" height="40" />
                            </clipPath>
                        </defs>
                        <g clipPath="url(#marketing-add-more)">
                            <g transform="translate(-1269.135 820.365) rotate(-45)">
                                <g transform="translate(-16803 -3223)">
                                    <line
                                        x2="20"
                                        transform="translate(18270.5 3568.5)"
                                        fill="none"
                                        stroke="#2c414c"
                                        strokeWidth="3"
                                    />
                                    <line
                                        y1="20"
                                        transform="translate(18280.5 3558.5)"
                                        fill="none"
                                        stroke="#2c414c"
                                        strokeWidth="3"
                                    />
                                </g>
                                <g
                                    transform="translate(1462 330)"
                                    fill="none"
                                    stroke="#2c414c"
                                    strokeWidth="3"
                                >
                                    <circle
                                        cx="15.5"
                                        cy="15.5"
                                        r="15.5"
                                        stroke="none"
                                    />
                                    <circle
                                        cx="15.5"
                                        cy="15.5"
                                        r="14"
                                        fill="none"
                                    />
                                </g>
                            </g>
                        </g>
                    </svg>
                    ADD MORE
                </div>
                <div
                    className="d-flex flex-row-reverse"
                    style={{ width: '100%', paddingTop: '50px' }}
                >
                    <div className="p-2">
                        <button
                            type="button"
                            className="btnStep1"
                            style={{ backgroundColor: '#d86b59' }}
                        >
                            Next
                        </button>
                    </div>
                </div>
            </section>
        </section>
    </MarketingStepsShell>
);

export default MarketingStep3Preview;
